import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
// import style from './style.module.scss';
import SportsTeamLogo from '../../../../../../components/teamLogo';
import { Wrap, WrapHeader, Tab, Button, Contents, Header, Ul } from './styled';

const BaseballMatchRankTable = observer(({ data }) => {
  const [list, setList] = useState([]);
  const { tabs, selectedTab, setSelectedTab, rankList, homeId, awayId } = data;

  useEffect(() => {
    setList(rankList);
  }, [selectedTab, rankList]);

  return (
    <Wrap>
      <WrapHeader>
        <h2>리그 순위</h2>
        <ul>
          {tabs.map((item, idx) => {
            return (
              <li key={idx} className={clsx(selectedTab === item.key && 'on')}>
                <button onClick={() => setSelectedTab(item.key)}>
                  {item.value}
                </button>
              </li>
            );
          })}
        </ul>
      </WrapHeader>

      <Contents>
        <Header>
          <div className={'rank'}>순위</div>
          <div className={'team'}>팀명</div>
          <div className={'game'}>경기</div>
          <div className={'win'}>승</div>
          <div className={'draw'}>무</div>
          <div className={'loss'}>패</div>
          <div className={'winPer'}>승차</div>
        </Header>
        <Ul>
          {list.length > 0 ? (
            list.map((item, idx) => {
              return (
                <li
                  key={`${item.id}${idx}`}
                  className={clsx(
                    homeId === item.teamId && 'active',
                    awayId === item.teamId && 'active'
                  )}
                >
                  <div className={'rank'}>{item.ranking}</div>
                  <div className={'team'}>
                    <SportsTeamLogo
                      imgSize={21}
                      imgUrl={item.teamEmblemPath}
                      isLazy={false}
                    />
                    <span>{item.teamName}</span>
                  </div>
                  <div className={'game'}>{item.gameCount}</div>
                  <div className={'win'}>{item.winCount}</div>
                  <div className={'draw'}>{item.drawCount}</div>
                  <div className={'loss'}>{item.lossCount}</div>
                  <div className={'winPer'}>{item.winPoint}</div>
                </li>
              );
            })
          ) : (
            <li className="empty">
              <div>랭킹 정보가 없습니다.</div>
            </li>
          )}
        </Ul>
      </Contents>
    </Wrap>
  );
});

export default BaseballMatchRankTable;
